import { useCallback, useEffect, useRef, useState } from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { useParams } from "react-router";

import * as api from "../../api/api";
import { Breadcrumbs, breadcrumbPaths } from "../../components/Breadcrumbs";
import Layout from "../../components/Layout/Layout";

export default function ResultPage() {
    const { organizationId, locationId, missionId, resultId, filename } =
        useParams();
    const [status, setStatus] = useState("pending");
    const hasRedirected = useRef(false);

    const handleDownload = useCallback(async () => {
        setStatus("pending");
        try {
            await api.downloadResult(
                organizationId,
                locationId,
                missionId,
                resultId,
                filename,
                false,
            );
            setStatus("success");
        } catch (err) {
            console.error("Download failed:", err);
            setStatus("error");
        }
    }, [organizationId, locationId, missionId, resultId, filename]);

    // Automatic redirect
    useEffect(() => {
        if (!hasRedirected.current) {
            hasRedirected.current = true;
            handleDownload();
        }
    }, [handleDownload]);

    return (
        <Layout>
            <title>Result | MyCorvus</title>
            <Breadcrumbs path={breadcrumbPaths.resultFile} />

            <Card>
                <Card.Body>
                    {status === "success" && (
                        <>
                            Your download should have been started. If it did
                            not, &nbsp;
                            <Button
                                variant="link"
                                className="p-0 align-baseline"
                                onClick={handleDownload}
                            >
                                click here
                            </Button>
                            .
                        </>
                    )}
                    {status === "pending" && (
                        <>
                            The page will redirect to your result. If nothing
                            happens,&nbsp;
                            <Button
                                variant="link"
                                className="p-0 align-baseline"
                                onClick={handleDownload}
                            >
                                click here
                            </Button>
                            .
                        </>
                    )}

                    {status === "error" && (
                        <Alert variant="danger">
                            The file could not be accessed. You may not have
                            permission to view it, or it may no longer exist.
                            <div className="mt-3">
                                <Button onClick={handleDownload}>
                                    Try Again
                                </Button>
                            </div>
                        </Alert>
                    )}
                </Card.Body>
            </Card>
        </Layout>
    );
}
